import { api } from '../api.ts';
import { initialen } from './namen.ts';

// ============================================================================
// Ein Gesicht zu einem Namen.
//
// ORIGINALTEXT MARVIN (02.09.2026)
//   „für alle benutzer die möglichkeit schaffen, dass man ein profilbild
//    hochladen kann, das soll dann unten links in dem kreis angezeigt werden
//    bzw bei der auftragsinfo bei den benutzern."
//
// ES STEHT EINMAL DA UND NICHT AN DREI STELLEN. Der Kreis kommt unten links
// in der Seitenleiste vor, neben jedem Eintrag der Auftragsinfo und in „Meine
// Anmeldung"; die Initialen wurden bisher in `App.tsx` gerechnet und
// nirgendwo sonst. Drei Abschriften heissen, dass die dritte irgendwann
// etwas anderes zeigt - dieselbe Lehre wie beim Seitenrand und bei der
// Schriftgrösse.
//
// UND OB EIN BILD DA IST, WIRD GESAGT UND NICHT PROBIERT. Die Anzeige
// erkennt es NICHT am Ladefehler des Bildes: das schreibt bei jedem
// Seitenaufruf einen erwarteten Fehler in die Browserkonsole, und eine
// Konsole, in der dauerhaft ein erwarteter Fehler steht, ist eine Konsole, in
// der man den unerwarteten übersieht. Genau daran ist Prüfstand 014 beim
// Firmenzeichen schon einmal rot geworden.
// ============================================================================

/* DIE REINEN NAMENSREGELN STEHEN IN `namen.ts`, ohne JSX daneben:
   diese Datei zeichnet einen Kreis und laesst sich deshalb von keinem
   Pruefstand laden. Weitergereicht werden sie hier, damit der Aufrufer
   nur EINE Adresse fuer „alles, was mit einem Namen zu tun hat" hat. */
export { initialen, vorname, kurzeNamen } from './namen.ts';

/**
 * Der Kreis mit dem Bild - oder mit den Initialen, wenn keines da ist.
 *
 * DER NAME STEHT IMMER DANEBEN und nie NUR im Bild. Ein Gesicht in einem Feld
 * von 28 Pixeln beantwortet die Frage „von wem ist das" schnell, aber nicht
 * sicher; wer nur das Bild zeigt, nimmt dem Leser die Auskunft, sobald zwei
 * Menschen einen ähnlichen Haarschnitt haben. Der Kreis trägt deshalb den
 * Namen als Titel und ist für Vorleseprogramme still.
 */
export function Gesicht({
  benutzerId, name, hatBild, stempel, gross, klein,
}: {
  /** Wessen Bild. Ohne Kennung gibt es nur Initialen. */
  benutzerId?: string | null;
  name: string;
  hatBild?: boolean;
  /** Wechselt nach einem Wechsel des Bildes. Siehe `profilbildAdresse`. */
  stempel?: string | number;
  /** 88 Pixel, für „Meine Anmeldung". */
  gross?: boolean;
  /** 28 Pixel, für eine Zeile in einer Liste. */
  klein?: boolean;
}) {
  const zeigen = !!(hatBild && benutzerId);
  return (
    <span className={'profilkreis' + (gross ? ' gross' : '')
                                   + (klein ? ' klein' : '')}
          title={name} aria-hidden="true">
      {zeigen
        ? <img src={api.profilbildAdresse(benutzerId!, stempel)} alt="" />
        : <span>{initialen(name)}</span>}
    </span>
  );
}
